import { render, staticRenderFns } from "./AdvanceDelivery.vue?vue&type=template&id=7959c1dc&scoped=true&"
import script from "./AdvanceDelivery.vue?vue&type=script&lang=js&"
export * from "./AdvanceDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7959c1dc",
  null
  
)

export default component.exports